var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7946D9",
    fillRule: "evenodd",
    d: "M18.14 10.612l-3.256 2.857H9.768l-2.79 2.449v-2.449H2.79V1.633h15.35v8.979zM.93 0L0 3.265V17.96h4.187V20H6.51l2.327-2.041h3.72L20 11.429V0H.93zm6.977 9.796h1.86V4.897h-1.86v4.899zm5.116 0h1.86V4.897h-1.86v4.899z"
  })));
}

export default SvgTwitch;